import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindAllUsersInFirmQueryVariables = Types.Exact<{
  firmAccountId: Types.Scalars['String'];
  searchWord?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type FindAllUsersInFirmQuery = { __typename?: 'Query', findAllUsersInFirm: Array<{ __typename?: 'UserEntity', id: string, UserInformation?: { __typename?: 'UserInformationEntity', lastName: string, firstName: string } | null, UserFirmAccount?: Array<{ __typename?: 'UserFirmAccountEntity', id: string, userId?: string | null, firmAccountId: string, Roles?: { __typename?: 'RolesEntity', description: string } | null }> | null, Entity?: { __typename?: 'Entity', UserFirmAccount?: Array<{ __typename?: 'UserFirmAccountEntity', id: string, entityId?: string | null, firmAccountId: string, Roles?: { __typename?: 'RolesEntity', description: string } | null, Entity?: { __typename?: 'Entity', id: string, Users?: { __typename?: 'UserEntity', id: string } | null } | null }> | null } | null }> };

export type GetUserChannelsQueryVariables = Types.Exact<{
  searchWord?: Types.InputMaybe<Types.Scalars['String']>;
  take?: Types.InputMaybe<Types.Scalars['Float']>;
  skip?: Types.InputMaybe<Types.Scalars['Float']>;
}>;


export type GetUserChannelsQuery = { __typename?: 'Query', userChannels: Array<{ __typename?: 'UserChannelEntity', id: string, createAt: any, updateAt: any, description?: string | null, online?: boolean | null, Messages?: Array<{ __typename?: 'MessageEntity', id: string, text?: string | null, userId: string, createAt: any, updateAt: any, readDate?: any | null, channelId: string, attachment?: string | null, isSms: boolean, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, createAt?: any | null, updateAt?: any | null, birthday?: any | null, lastName: string, firstName: string } | null } | null }> | null, ChannelMembers?: Array<{ __typename?: 'ChannelMemberEntity', id: string, userId: string, createAt: any, channelId: string, lastConnection: any, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, createAt?: any | null, updateAt?: any | null, birthday?: any | null, lastName: string, firstName: string, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, type: Types.PhoneType, value: string, createAt: any, updateAt: any }> | null } | null, FirmAccount?: Array<{ __typename?: 'FirmAccountEntity', id: string, name?: string | null, Interviews?: Array<{ __typename?: 'InterviewEntity', id: string, name: string, TaxYearInterview?: Array<{ __typename?: 'TaxYearInterviewEntity', id: string, taxYearId: string, TaxYear?: { __typename?: 'TaxYearEntity', year: number } | null }> | null }> | null }> | null, Entity?: { __typename?: 'Entity', id: string } | null } | null }> | null }> };

export type AiMessageSuggestionQueryVariables = Types.Exact<{
  channelId: Types.Scalars['String'];
}>;


export type AiMessageSuggestionQuery = { __typename?: 'Query', AIMessageSuggestion?: { __typename?: 'OpenaiChatCompletionEntity', id: string, choices?: Array<{ __typename?: 'OpenaiChoiceEntity', index: number, finish_reason: string, message: { __typename?: 'OpenaiMessageEntity', role: string, content: string } }> | null } | null };

export type GetChannelMessagesQueryVariables = Types.Exact<{
  channelId: Types.Scalars['String'];
  take?: Types.InputMaybe<Types.Scalars['Float']>;
  skip?: Types.InputMaybe<Types.Scalars['Float']>;
}>;


export type GetChannelMessagesQuery = { __typename?: 'Query', getChannelMessages: Array<{ __typename?: 'MessageEntity', id: string, text?: string | null, userId: string, createAt: any, updateAt: any, readDate?: any | null, channelId: string, attachment?: string | null, isSms: boolean, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, createAt?: any | null, updateAt?: any | null, birthday?: any | null, lastName: string, firstName: string } | null } | null }> };

export type GetAiAgentMessagesQueryVariables = Types.Exact<{
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetAiAgentMessagesQuery = { __typename?: 'Query', getAiAgentMessages: { __typename?: 'AiAgentMessagesEntity', pagination: { __typename?: 'AiAgentMessagesPaginationEntity', total: number, skip: number, take: number }, data: Array<{ __typename?: 'AiAgentMessageEntity', id: string, type: string, text?: string | null, more?: string | null, createAt: any }> } };


export const FindAllUsersInFirmDocument = gql`
    query FindAllUsersInFirm($firmAccountId: String!, $searchWord: String) {
  findAllUsersInFirm(firmAccountId: $firmAccountId, searchWord: $searchWord) {
    id
    UserInformation {
      lastName
      firstName
    }
    UserFirmAccount {
      id
      userId
      firmAccountId
      Roles {
        description
      }
    }
    Entity {
      UserFirmAccount {
        id
        entityId
        firmAccountId
        Roles {
          description
        }
        Entity {
          id
          Users {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindAllUsersInFirmQuery__
 *
 * To run a query within a React component, call `useFindAllUsersInFirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllUsersInFirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllUsersInFirmQuery({
 *   variables: {
 *      firmAccountId: // value for 'firmAccountId'
 *      searchWord: // value for 'searchWord'
 *   },
 * });
 */
export function useFindAllUsersInFirmQuery(baseOptions: Apollo.QueryHookOptions<FindAllUsersInFirmQuery, FindAllUsersInFirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllUsersInFirmQuery, FindAllUsersInFirmQueryVariables>(FindAllUsersInFirmDocument, options);
      }
export function useFindAllUsersInFirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllUsersInFirmQuery, FindAllUsersInFirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllUsersInFirmQuery, FindAllUsersInFirmQueryVariables>(FindAllUsersInFirmDocument, options);
        }
export type FindAllUsersInFirmQueryHookResult = ReturnType<typeof useFindAllUsersInFirmQuery>;
export type FindAllUsersInFirmLazyQueryHookResult = ReturnType<typeof useFindAllUsersInFirmLazyQuery>;
export type FindAllUsersInFirmQueryResult = Apollo.QueryResult<FindAllUsersInFirmQuery, FindAllUsersInFirmQueryVariables>;
export const GetUserChannelsDocument = gql`
    query getUserChannels($searchWord: String, $take: Float, $skip: Float) {
  userChannels(searchWord: $searchWord, take: $take, skip: $skip) {
    id
    createAt
    updateAt
    description
    online
    Messages {
      id
      text
      userId
      createAt
      updateAt
      readDate
      channelId
      attachment
      isSms
      Users {
        id
        email
        createAt
        updateAt
        languageId
        UserInformation {
          id
          userId
          createAt
          updateAt
          birthday
          lastName
          firstName
        }
      }
    }
    ChannelMembers {
      id
      userId
      createAt
      channelId
      lastConnection
      Users {
        id
        email
        createAt
        updateAt
        languageId
        UserInformation {
          id
          userId
          createAt
          updateAt
          birthday
          lastName
          firstName
          Phones {
            id
            type
            value
            createAt
            updateAt
          }
        }
        FirmAccount {
          id
          name
          Interviews {
            id
            name
            TaxYearInterview {
              id
              taxYearId
              TaxYear {
                year
              }
            }
          }
        }
        Entity {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserChannelsQuery__
 *
 * To run a query within a React component, call `useGetUserChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChannelsQuery({
 *   variables: {
 *      searchWord: // value for 'searchWord'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetUserChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserChannelsQuery, GetUserChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserChannelsQuery, GetUserChannelsQueryVariables>(GetUserChannelsDocument, options);
      }
export function useGetUserChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserChannelsQuery, GetUserChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserChannelsQuery, GetUserChannelsQueryVariables>(GetUserChannelsDocument, options);
        }
export type GetUserChannelsQueryHookResult = ReturnType<typeof useGetUserChannelsQuery>;
export type GetUserChannelsLazyQueryHookResult = ReturnType<typeof useGetUserChannelsLazyQuery>;
export type GetUserChannelsQueryResult = Apollo.QueryResult<GetUserChannelsQuery, GetUserChannelsQueryVariables>;
export const AiMessageSuggestionDocument = gql`
    query AIMessageSuggestion($channelId: String!) {
  AIMessageSuggestion(channelId: $channelId) {
    id
    choices {
      index
      message {
        role
        content
      }
      finish_reason
    }
  }
}
    `;

/**
 * __useAiMessageSuggestionQuery__
 *
 * To run a query within a React component, call `useAiMessageSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiMessageSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiMessageSuggestionQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useAiMessageSuggestionQuery(baseOptions: Apollo.QueryHookOptions<AiMessageSuggestionQuery, AiMessageSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiMessageSuggestionQuery, AiMessageSuggestionQueryVariables>(AiMessageSuggestionDocument, options);
      }
export function useAiMessageSuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiMessageSuggestionQuery, AiMessageSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiMessageSuggestionQuery, AiMessageSuggestionQueryVariables>(AiMessageSuggestionDocument, options);
        }
export type AiMessageSuggestionQueryHookResult = ReturnType<typeof useAiMessageSuggestionQuery>;
export type AiMessageSuggestionLazyQueryHookResult = ReturnType<typeof useAiMessageSuggestionLazyQuery>;
export type AiMessageSuggestionQueryResult = Apollo.QueryResult<AiMessageSuggestionQuery, AiMessageSuggestionQueryVariables>;
export const GetChannelMessagesDocument = gql`
    query GetChannelMessages($channelId: String!, $take: Float, $skip: Float) {
  getChannelMessages(channelId: $channelId, take: $take, skip: $skip) {
    id
    text
    userId
    createAt
    updateAt
    readDate
    channelId
    attachment
    isSms
    Users {
      id
      email
      createAt
      updateAt
      languageId
      UserInformation {
        id
        userId
        createAt
        updateAt
        birthday
        lastName
        firstName
      }
    }
  }
}
    `;

/**
 * __useGetChannelMessagesQuery__
 *
 * To run a query within a React component, call `useGetChannelMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelMessagesQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetChannelMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetChannelMessagesQuery, GetChannelMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelMessagesQuery, GetChannelMessagesQueryVariables>(GetChannelMessagesDocument, options);
      }
export function useGetChannelMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelMessagesQuery, GetChannelMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelMessagesQuery, GetChannelMessagesQueryVariables>(GetChannelMessagesDocument, options);
        }
export type GetChannelMessagesQueryHookResult = ReturnType<typeof useGetChannelMessagesQuery>;
export type GetChannelMessagesLazyQueryHookResult = ReturnType<typeof useGetChannelMessagesLazyQuery>;
export type GetChannelMessagesQueryResult = Apollo.QueryResult<GetChannelMessagesQuery, GetChannelMessagesQueryVariables>;
export const GetAiAgentMessagesDocument = gql`
    query GetAiAgentMessages($take: Int, $skip: Int) {
  getAiAgentMessages(take: $take, skip: $skip) {
    pagination {
      total
      skip
      take
    }
    data {
      id
      type
      text
      more
      createAt
    }
  }
}
    `;

/**
 * __useGetAiAgentMessagesQuery__
 *
 * To run a query within a React component, call `useGetAiAgentMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiAgentMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiAgentMessagesQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetAiAgentMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetAiAgentMessagesQuery, GetAiAgentMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiAgentMessagesQuery, GetAiAgentMessagesQueryVariables>(GetAiAgentMessagesDocument, options);
      }
export function useGetAiAgentMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiAgentMessagesQuery, GetAiAgentMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiAgentMessagesQuery, GetAiAgentMessagesQueryVariables>(GetAiAgentMessagesDocument, options);
        }
export type GetAiAgentMessagesQueryHookResult = ReturnType<typeof useGetAiAgentMessagesQuery>;
export type GetAiAgentMessagesLazyQueryHookResult = ReturnType<typeof useGetAiAgentMessagesLazyQuery>;
export type GetAiAgentMessagesQueryResult = Apollo.QueryResult<GetAiAgentMessagesQuery, GetAiAgentMessagesQueryVariables>;
export const namedOperations = {
  Query: {
    FindAllUsersInFirm: 'FindAllUsersInFirm',
    getUserChannels: 'getUserChannels',
    AIMessageSuggestion: 'AIMessageSuggestion',
    GetChannelMessages: 'GetChannelMessages',
    GetAiAgentMessages: 'GetAiAgentMessages'
  }
}